import React, { useState } from "react";
import { MessageType } from "../../../models/media.models";
import Mention from '../../shared/mentions';
import { Tags } from "../../shared/constants";
import ImageOrVideo from "../../shared/media/imageOrVideo.component";
import Audio from "./audio.component";
import File from "./file.component";
import { MediaModel } from "../../../models/templates.models";
import { FileService } from "../../../services/FileService";
import { indexOf, lastIndexOf } from "lodash";
import { ChannelType } from "../../../models/channels/channels.model";

interface IProps {
    Mediatype: string;
    Value: string;
    InBound?: boolean;
    Channel?: number;
    IsWidget?: boolean;
    IsMobile?: boolean;
}

const MultiMedia: React.FC<IProps> = (props: IProps) => {
    const [open, setOpen] = useState<boolean>()
    const [url, setUrl] = useState<string>()

    const mediaDisplay = () => {
        setOpen(true)
    }

    const mediaClose = () => {
        setOpen(false)
    }

    const fileDownload = (src: string) => {
        fetch(src).then(response => {
            response.blob().then(blob => {
                const url = URL.createObjectURL(blob);
                const link = document.createElement("a");
                link.href = url;
                link.setAttribute("download", src.substring(src.lastIndexOf("/") + 1));
                link.click();
            })
        })
    }

    const mediaDownload = (value) => {
        FileService.downLoadFile(value).then((response) => {
            const url = URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", value);
            link.click();
        });
    }

    const file = (str: string) => {
        const data = {} as MediaModel
        data.Name = str.split('file/')[1] || str.substring(str.lastIndexOf("/") + 1, str.indexOf("?"))
        data.ID = new Date().valueOf().toString()
        data.Url = str
        data.ContentType = props.Mediatype
        return data
    }

    switch (props.Mediatype) {
        case MessageType.IMAGE:
        case MessageType.VIDEO:
            return <div className='d-flex align-center'><ImageOrVideo MediaUrl={props.Value} open={open} controls={true} mediaDisplay={mediaDisplay} fileDownload={() => fileDownload(props.Value)} onClose={mediaClose} senderName="" MediaType={props.Mediatype} classname="display-media" IsWidget={props.IsWidget} /></div>
        case MessageType.AUDIO:
            return <div className='d-flex align-center'><Audio controls={true} MediaUrl={props.Value} />
            </div>
        case MessageType.FILE:
            return <div className='d-flex align-center'><File media={file(props.Value)} fileDownload={() => fileDownload(props.Value)} cross={false} /></div>
        case MessageType.TEXT:
            return <span className={`${props.Channel === ChannelType.LIVE_CHAT ? props.IsMobile ? "r-h5-regular d-flex justify-center " : "r-h4-regular d-flex justify-center" : "h5-regular ph-no-capture"}`} style={{ wordBreak: "break-word" }}><Mention body={props.Value} tags={Tags} emoji={''} openTags={false} tagTarget={undefined} onChange={() => { }} onKeyDown={() => { }} closeTags={() => { }} maxLength={props.Value.length} id={''} placeholder={''} readOnly={true} IsOutbound={!props.InBound} IsLinkAllowed={true} /></span>
        default:
            return <span className={`${props.Channel === ChannelType.LIVE_CHAT ? "live-chat-conversation-history" : "h5-regular"}`} style={{ wordBreak: "break-word" }}> <Mention body={props.Value} tags={[]} emoji={''} openTags={false} tagTarget={undefined} onChange={() => { }} onKeyDown={() => { }} closeTags={() => { }} maxLength={props.Value.length} id={''} placeholder={''} readOnly={true} IsOutbound={!props.InBound} IsLinkAllowed={true} /></span>
    }

}



export default MultiMedia;

